import React from "react";

const MustBeSignedInPage = () => {
    return <h1>You must be signed in to access this page. Sign in above to continue.</h1>;
  };
  
  export default MustBeSignedInPage;